import AutoCompleteUIDTO from "../dto/AutoCompleteUIDTO";
import ApiResponseV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/ApiResponseV2";
import PagedResult from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/PagedResult";
import GenericCrudServiceV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/GenericCrudServiceV2";
import HttpClientV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/HttpClientV2";
import Position from "../models/Position";

class PositionService extends GenericCrudServiceV2<Position> {
  readonly path: string;

  constructor(path: string) {
    super(path);
    this.path = path;
  }

  findByProjectExternalIdAndRoleKey(
    page: number,
    pageSize: number,
    projectExternalId: string,
    roleKey: string,
    positionStatus: boolean,
  ): Promise<ApiResponseV2<PagedResult<Position>>> {
    let query = `${this.basePath}/find-filtered?page=${page}&pageSize=${pageSize}&projectExternalId=${projectExternalId}&roleKey=${roleKey}&positionStatus=${positionStatus}`;
    return HttpClientV2.get(query);
  }

  findPositionNamesByProjectId(projectExternalId: string, startDate?: string): Promise<ApiResponseV2<AutoCompleteUIDTO[]>> {
    return HttpClientV2.get(
      `${this.basePath}/position-names?projectExternalId=${projectExternalId}${startDate ? `&startDate=${startDate}` : ""}`,
    );
  }

  findProjectUserListFromManager(): Promise<ApiResponseV2<AutoCompleteUIDTO[]>> {
    return HttpClientV2.get(`${this.basePath}/assigned-to`);
  }

  findPositionByExternalId(externalId: string): Promise<ApiResponseV2<Position>> {
    return HttpClientV2.get(`${this.basePath}/${externalId}`);
  }
}

export default new PositionService("/ensolvers-ops/positions");
